import React from 'react';
import AppTemplate from 'components/base/template/AppTemplate';
import AppNav from 'components/base/nav/AppNav';
import PartnerContainer from 'containers/partner/PartnerContainer';
import { useLocation } from 'react-router';

function Partner() {
  const { pathname } = useLocation();

  return (
    <AppTemplate
      title={'Partner'}
      leftSide={<AppNav />}
      mainStyle={{
        // padding: '0 50px',
        padding: '0 0 0 40px',
      }}
    >
      <PartnerContainer />
    </AppTemplate>
  );
}

export default Partner;
